export default __webpack_public_path__ + "static/styledComponents-a32555cd123e8310374d68fcedfd900b.png";